import styled from 'styled-components';

type Props = {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
};

const Margin = styled.div<Props>`
  margin-top: ${({ top }): number => top || 0}px;
  margin-right: ${({ right }): number => right || 0}px;
  margin-bottom: ${({ bottom }): number => bottom || 0}px;
  margin-left: ${({ left }): number => left || 0}px;
`;
Margin.displayName = 'Margin';

export default Margin;
